import TestDetailsMixins from "@/mixins/testDetailMixins";

export default {
  data: () => ({
    dropDownInterval: undefined,
  }),
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    waitUntil(conditionFn) {
      let pollInterval = 50;
      let timeout = null;
      return {
        every(ms) {
          pollInterval = ms;
          return this;
        },
        for(ms) {
          timeout = ms;
          return this;
        },
        do(actionFn) {
          return new Promise((resolve, reject) => {
            let intervalId;
            let timeoutId;

            const cleanUp = () => {
              clearInterval(intervalId);
              clearTimeout(timeoutId);
            };

            if (timeout) {
              timeoutId = setTimeout(() => {
                cleanUp();
                reject(new Error(`waitUntil timed out after ${timeout}ms.`));
              }, timeout);
            }

            intervalId = setInterval(() => {
              try {
                if (conditionFn()) {
                  cleanUp();
                  actionFn();
                  resolve();
                }
              } catch (e) {
                cleanUp();
                reject(e);
              }
            }, pollInterval);
          });
        },
      };
    },
    async checkCsvColumns(csv, columns) {
      if (typeof csv === "object") {
        if (csv) {
          csv = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener(
              "load",
              () => {
                resolve(reader.result);
              },
              false
            );
            reader.readAsText(csv);
          });
        }
      }
      if (Array.isArray(csv)) {
        if (csv.length === 0) {
          return false;
        }
        if (csv.length > 0) {
          const csvColumns = csv[0];
          return columns.every((x) => csvColumns.includes(x));
        }
      }
      if (typeof csv === "string") {
        if (csv.includes("\n")) {
          csv = csv.split("\n")[0];
        }
        csv = csv.trim().split(",");
        return columns.every((x) => csv.includes(x));
      }
    },
    generateTestcaseMeta(payload) {
      const copy = JSON.parse(JSON.stringify(this.$store.state.dialog.changed));
      Object.entries(copy).forEach(([key, value]) => {
        copy[key] = {
          ...value,
          foreignId: payload,
          foreignType: "Test",
        };
      });
      return copy;
    },
    trim(value) {
      if (value) {
        return value.toString().trim();
      }
      return value;
    },
    logChange(
      params = {
        ref: "",
        newValue: "",
        oldValue: "",
        variable: "",
        change: "",
        internal: false,
        tab: "",
        dialog: "",
        foreignId: "",
        foreignType: "",
        func: "",
      }
    ) {
      const payload = {
        ...params,
        logVersion: 1,
      };

      payload.valid = true;

      if (payload.variable) {
        if (payload.ref) {
          payload.oldValue = payload.ref[payload.variable] ?? "";
          payload.ref[payload.variable] = payload.newValue;
        } else {
          payload.oldValue = this[payload.variable] ?? "";
          this[payload.variable] = payload.newValue;
        }
      }

      if (payload.validRef) {
        payload.valid = this.$refs[payload.validRef].validate();
      }

      if (payload.func && typeof payload.func === "function") {
        if (Array.isArray(payload.newValue)) {
          payload.newValue = payload.newValue.map(payload.func);
        } else {
          payload.newValue = payload.func(payload.newValue);
        }
        if (Array.isArray(payload.oldValue)) {
          payload.oldValue = payload.oldValue.map(payload.func);
        } else {
          payload.oldValue = payload.func(payload.oldValue);
        }
      }

      this.$store.dispatch("dialog/changeValue", payload).then(() => {});
    },
    bulkChangeValue(list = [], changes = "", extra = { internal: false, tab: "" }) {
      return list.map((row) => {
        return {
          id: row?.id || "",
          metaData: {
            name: `${row?.name || ""} (${row?.id || ""})`,
            old: "",
            new: changes,
            foreignId: row?.id,
            ...extra,
            teamId: this.$store.state.window.team_id,
          },
        };
      });
    },
    changeValue(
      value,
      ref,
      variable,
      name,
      tab = "",
      internal = false,
      mapFunction = null,
      extra = {
        foreignId: "",
        foreignType: "",
      }
    ) {
      try {
        const payload = {
          newValue: value,
          oldValue: ref?.[variable] ?? variable,
          name,
          tab,
          internal,
          variable,
          extra,
        };

        if (mapFunction && typeof mapFunction === "function") {
          if (Array.isArray(payload.newValue)) {
            payload.newValue = payload.newValue.map(mapFunction);
          } else {
            payload.newValue = mapFunction(value);
          }
          if (Array.isArray(payload.newValue)) {
            payload.oldValue = payload.oldValue.map(mapFunction);
          } else {
            payload.oldValue = mapFunction(payload.oldValue);
          }
        }
        this.$store.dispatch("dialog/changeValue", payload).then(() => {});
        if (variable) {
          ref[variable] = value;
        }
      } catch (e) {
        console.log(e);
        if (variable) {
          ref[variable] = value;
        }
      }
    },
    sequencer() {
      class Sequencer {
        constructor() {
          this.queue = [];
        }

        push(fn) {
          this.queue.push(fn);
          return this;
        }

        process() {
          const fn = this.queue.shift();
          if (fn) {
            fn.method.apply(null, fn.args)?.then(() => this.process());
          } else {
            setTimeout(() => this.process(), 2000);
          }
        }
      }

      return new Sequencer();

      // this.call = this.sequencer();
      // this.call.push({
      //   method: () => {},
      //   args: ["1 CALL"],
      // });
      // this.call.process();
      // this.call.push({
      //   method: () => {},
      //   args: ["2 CALL"],
      // });
      // this.call.push({
      //   method: () => {},
      //   args: ["3 CALL"],
      // });
    },
    valueOr(x, y) {
      try {
        if (x) {
          return x;
        }
      } catch (e) {}
      return y;
    },
    scrollToError() {
      setTimeout(() => {
        document.querySelector(".error--text")?.scrollIntoView({
          block: "nearest",
          behavior: "smooth",
          inline: "nearest",
        });
      }, 200);
    },
    scrollToErrorInTab(refName, tab, ref) {
      setTimeout(() => {
        this.alwaysArray(this.$refs?.[refName]?.$children).map((x, index) => {
          try {
            if (x.$el?.querySelector(".error--text")) {
              ref[tab] = index;
              setTimeout(() => {
                this.scrollToError();
              }, 400);
            }
          } catch (_) {
            // console.log(_);
          }
        });
      }, 200);
    },
    hideBodyScroll() {
      const scrollTop = document.documentElement.scrollTop;
      const scrollLeft = document.documentElement.scrollLeft;
      window.onscroll = () => {
        window.scrollTo(scrollLeft, scrollTop);
      };
    },
    showBodyScroll() {
      window.onscroll = () => {};
    },
    centerDialog() {
      Array.from(document.getElementsByClassName("v-dialog")).map((n) => {
        n.style.left = "";
        n.style.top = "";
      });
    },
    syncBodyScroll(value) {
      if (value) {
        this.hideBodyScroll();
      } else {
        this.showBodyScroll();
        setTimeout(() => {
          this.centerDialog();
        }, 800);
      }
    },
    capitalize(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toUpperCase() : word.toLowerCase();
        })
        .replace(/\s+/g, "");
    },
    camelCase(str) {
      try {
        return String(str[0]).toUpperCase() + str.slice(1);
      } catch (e) {
        return str;
      }
    },
    UUID(pattern = "xxxx-xxxx-xxxx-yxxx-xxxx") {
      return pattern.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    boolean(value) {
      return [1, "1", true, "true", "y", "yes", "Y", "YES", "Yes", "TRUE"].includes(value);
    },
    alertForDisableInputs() {},
    downloadFile(filename, text) {
      const el = document.createElement("a");
      el.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
      el.setAttribute("download", filename);
      el.style.display = "none";
      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },
    formData(data) {
      if (!(data instanceof Object)) {
        throw new Error("Data: data must be an object");
      }
      const form = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.map((x) => form.append(key + "[]", x));
        } else {
          form.append(key, value);
        }
      });
      return form;
    },
    objectToFormDataObject(object, formData, text = "") {
      Object.entries(this.alwaysObject(object)).map(([key, value]) => {
        let __text = key;
        if (text.length !== 0) {
          __text = text + "[" + key + "]";
        }
        if (value && typeof value === "object") {
          this.objectToFormDataObject(value, formData, __text);
        } else {
          formData[__text] = value;
        }
      });
    },
    parseDate(date, format = "d mmm yyyy HH:MM") {
      const dateChecker = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/;
      if (!dateChecker.test(date.toString())) {
        console.error("type invalid: " + date);
        return date;
      }
      const datetime = new Date(date);
      return datetime.format(format, true);
    },
    encodeBase64: (data) => {
      return btoa(String.fromCharCode.apply(null, new Uint8Array(data)));
    },
    decodeBase64: (data) => {
      try {
        if (data) {
          const binaryString = atob(data);
          return new TextDecoder().decode(
            new Uint8Array([...binaryString].map((char) => char.charCodeAt(0)))
          );
        } else {
          return "";
        }
      } catch (e) {
        alert("Something went wrong, please visit our support page");
      }
    },
    ordinal_suffix_of(i) {
      const j = i % 10,
        k = i % 100;
      if (j === 1 && k !== 11) {
        return i + "st";
      }
      if (j === 2 && k !== 12) {
        return i + "nd";
      }
      if (j === 3 && k !== 13) {
        return i + "rd";
      }
      return i + "th";
    },
    jsonBody(data) {
      if (!(data instanceof Object)) {
        throw new Error("Data: data must be an object");
      }
      return JSON.stringify(data);
    },
    copy(data) {
      return JSON.parse(JSON.stringify(data));
    },
    redirectToUrlParamOrProject() {
      const url = new URL(window.location.href);
      const redirect = url.searchParams.get("url");
      if (redirect) {
        // Normalizes and removes invalid and unsafe characters from the URL (prevents forward slashes and javascript urls)
        let decodedUrl = decodeURIComponent(redirect).replace(/[^\w\.\/?&=-]/g, "");
        if (decodedUrl.length > 0) {
          // remove double slashes (prevents relative paths from becoming full urls)
          decodedUrl = decodedUrl.replace(/\/\/+/g, "/");

          // handle all urls as relative paths (also protects against full urls)
          if (!decodedUrl.startsWith("/")) {
            decodedUrl = "/" + decodedUrl;
          }

          window.location.href = decodedUrl;
        }
      }

      this.$router.push({ name: "Projects" }).then(() => {});
    },
    isObject(item) {
      return typeof item === typeof {} && !Array.isArray(item) && item !== null;
    },
    isArray(item) {
      return typeof item === typeof [] && Array.isArray(item);
    },
    alwaysObject(item) {
      return this.isObject(item) ? item : {};
    },
    alwaysArray(item) {
      return this.isArray(item) ? item : [];
    },
    openLink(link, newTab = false) {
      if (newTab) window.open(link, "_blank");
      else window.location.href = link;
    },
    notEmpty(item) {
      if (this.isObject(item)) {
        return Object.values(this.alwaysObject(item)).length > 0;
      } else if (this.isArray(item)) {
        return this.alwaysArray(item).length > 0;
      } else {
        return (item ?? "").toString().length > 0;
      }
    },
    plural(string, count) {
      if (count > 1) {
        return string + "s";
      }
      return string;
    },
    urlDecode(string) {
      let result = string;
      try {
        result = decodeURIComponent(string.toString());
        if (result === string) return result;
        return this.urlDecode(result);
      } catch (e) {
        return result;
      }
    },
    addHttps(string) {
      if (string.trim().startsWith("http")) {
        return string;
      }
      return "https://" + string;
    },
    htmlDecode(value) {
      if (!value) {
        return "";
      } else {
        const doc = new DOMParser().parseFromString(value, "text/html");
        return doc.documentElement.textContent;
      }
    },
    //check file extension
    checkSiteFileRestriction(imageName, windowVariables) {
      if (windowVariables.is_file_restriction == "1") {
        const allowed_file_extensions_lower = windowVariables.allowed_file_extensions.toLowerCase();
        const fileExtension = imageName.toString().split(".").slice(-1);
        if (!allowed_file_extensions_lower.split(",").includes(fileExtension[0].toLowerCase())) {
          this.$refs?.uploader?.reset();
          this.notify(
            "This file type has been restricted for upload. Please contact the site administrator for permissions.",
            "error"
          );
          return false;
        }
      }
      return true;
    },
    stringify(value) {
      if (value instanceof Object) {
        return JSON.stringify(value);
      }
      return value.toString();
    },
    timeString12hr(value) {
      try {
        return new Date("1970-01-01T" + value + ":00" + "Z").toLocaleTimeString("en-US", {
          timeZone: "UTC",
          hour12: true,
          hour: "numeric",
          minute: "numeric",
        });
      } catch (e) {
        console.warn(e);
        return "";
      }
    },
    timeString24(value) {
      if (!value) {
        console.warn("timeString24", value);
        return;
      }
      const [time, modifier] = value.split(" ");
      let [hours, minutes] = time.split(":");
      if (hours === "12") {
        hours = "00";
      }
      if (modifier.toLowerCase() === "pm") {
        hours = parseInt(hours, 10) + 12;
      }
      return `${hours.toString().padStart(2, "0")}:${minutes}`;
    },
    async capturePage(
      fileName = "export",
      element = document.body,
      pdf = false,
      callback = () => {}
    ) {
      const elements = document.getElementsByClassName("elevation-0");
      Array.from(elements).map((x) => x.classList.toggle("elevation-0"));
      const overflowElements = Array.from(
        document.getElementsByClassName("hide-over-flow-on-export")
      );

      overflowElements.map((x) => {
        x.setAttribute("fze-maxHeight", x.style.maxHeight);
        x.style.maxHeight = "100%";
      });

      const options = {
        logging: false,
        ignoreElements: (element) => {
          return Array.from(element.classList).includes("skip-capture");
        },
      };

      const { default: html2canvas } = await import(
        /* webpackChunkName: "html-2-canvas" */ "html2canvas"
      );
      const { PDFDocument } = await import(/* webpackChunkName: "pdf-lib" */ "pdf-lib");
      html2canvas(element, options).then(async function (canvas) {
        const image = canvas.toDataURL("image/png");

        if (pdf) {
          const height = element.clientHeight * 0.2645833333; // Convert px to mm
          const width = element.clientWidth * 0.2645833333; // Convert px to mm

          // Create a new PDF document
          const pdfDoc = await PDFDocument.create();

          // Add a blank page with the same dimensions as the element
          const page = pdfDoc.addPage([width, height]);

          // Embed the image into the PDF
          const pngImageBytes = await fetch(image).then((res) => res.arrayBuffer());
          const pngImage = await pdfDoc.embedPng(pngImageBytes);

          // Draw the image on the PDF page
          page.drawImage(pngImage, {
            x: 0,
            y: 0,
            width,
            height,
          });

          // Serialize the PDF to a Uint8Array and create a Blob
          const pdfBytes = await pdfDoc.save();
          const blob = new Blob([pdfBytes], { type: "application/pdf" });

          // Create a link to download the PDF
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName + ".pdf";
          link.click();
          link.remove();
        } else {
          // Handle PNG download (no change)
          const link = document.createElement("a");
          link.download = fileName + ".png";
          link.href = image;
          link.click();
          link.remove();
        }

        callback();
        Array.from(elements).map((x) => x.classList.toggle("elevation-0"));
        overflowElements.map((x) => {
          x.style.maxHeight = x.getAttribute("fze-maxHeight");
        });
      });
    },
    startDropDownListener() {
      let oldPositions = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const args = Array.from(arguments);
      this.dropDownInterval = setInterval(() => {
        args.map((ref, i) => {
          const rect = this.$refs[ref]?.$el?.getBoundingClientRect() ?? { x: 0, y: 0 };
          let position = rect.x;
          if (ref.endsWith("Y")) position += rect.y;
          if (Math.abs(position - oldPositions[i]) > 30) {
            oldPositions[i] = position;
            Object.keys(this.$refs)
              .filter((x) => x.startsWith("dropdown"))
              .map((x) => {
                if (this.$refs[x]?.isMenuActive) this.$refs[x].isMenuActive = false;
              });
          }
        });
      }, 400);
    },
    stopDropDownListener() {
      clearInterval(this.dropDownInterval);
    },
    stringSort(a, b, key) {
      const aKey = a[key]?.trim()?.[0];
      const bKey = b[key]?.trim()?.[0];
      if (aKey && bKey) {
        if (aKey < bKey) {
          return -1;
        }
        if (aKey > bKey) {
          return 1;
        }
        return 0;
      }
      return 0;
    },
    numberSort(a, b, key) {
      const aKey = parseInt(a[key]);
      const bKey = parseInt(b[key]);
      if (aKey < bKey) return -1;
      if (aKey > bKey) return 1;
      return 0;
    },
    ellipsis(string, length) {
      const text = String(string);
      if (text.length > length) {
        return text.slice(0, length) + "...";
      }
      return text;
    },
    nextTick(fn) {
      this.$nextTick(() => {
        if (typeof fn === "function") fn();
      });
    },
    doAfter(fn, time) {
      setTimeout(() => {
        if (typeof fn === "function") fn();
      }, time);
    },
    clearInvalid: (ref, item, list, key) => {
      const itemAvail = (item, list, key) => {
        return list?.find((x) => {
          if (key) {
            if (x[key] === item) {
              return true;
            } else {
              return item === x;
            }
          }
        });
      };
      if (Array.isArray(ref[item])) {
        let newList = [];
        ref[item].map((x) => {
          const result = itemAvail(x, ref[list], key);
          if (result) {
            newList.push(x);
          }
        });
        ref[item] = newList;
      } else {
        const result = itemAvail(ref[item], ref[list], key);
        if (!result) {
          ref[item] = "";
        }
      }
    },
    startPlugin(thisref, projectId) {
      let mode = "record";

      const detail = {
        fid: functioniseTabId,
        projectId: String(window.testcaseProject),
        device: {},
      };
      detail.editTestId = window.testId;
      detail.editActionId = window.actionId;
      detail.branch = window.branch;
      detail.editMode = mode;
      detail.isPageObject = window.flagPageObject;
      detail.windowWidth = window.windowWidth;
      detail.windowHeight = window.windowHeight;
      detail.projectId = String(projectId);
      const evtInit = { detail: detail, bubbles: true, cancelable: true };
      let startPluginTimeout = "";
      /* Start a timer to indicate to the user something went wrong if we are still on this page after 15 seconds */
      startPluginTimeout = setTimeout(function () {
        clearTimeout(startPluginTimeout);
        thisref.notify(
          "An internal error occurred. Please refresh the page and try again",
          "error"
        );
        //thisref.$store.commit("setCommonDialog", false);
      }, 40000);
      
      /**
       * Handles initialization of the Functionize Plugin event.
       * Depending on configuration and context, it either:
       * - Dispatches the event directly (if refactor is disabled), or
       * - Fetches or uses an existing Test Case ID before dispatching.
       */
      try {
        // Execute the AJAX call to fetch new test case ID
        this.J_POST("/uiapi/detail/getnewdummytestcaseid", {})
          .then((result) => {
            if (result?.status === "SUCCESS" && result?.testcaseId) {
              // Successful response — set test case details and dispatch event
              detail.entityId = result.testcaseId;
              detail.entityKind = 'test';
              evtInit.detail = detail;
              const evt = new CustomEvent("FunctionizePluginStartEvent", evtInit);
              document.body.dispatchEvent(evt);
              return;
            }

            // Log error for debugging
            console.error('Failed to fetch new test case ID', result);
          })
          .catch((error) => {
            // Handle network errors or promise rejections
            console.error('Network error while fetching test case ID:', error);
          });
      } catch (error) {
        console.error('Error initializing Functionize Plugin event:', error);
      }
    },
    splitArrayInto(arr, len) {
      let chunks = [],
        i = 0,
        n = arr.length;
      while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
      }
      return chunks;
    },
    setActionMetadata(ref, key, oldVal, newVal, internal = false) {
      if (typeof ref.metaData[key] == "undefined") {
        ref.metaData[key] = { old: "", new: "" };
        ref.metaData[key].old = oldVal;
      }
      ref.metaData[key].new = newVal;
      if (internal) {
        ref.metaData[key].internal = true;
      }
      if (oldVal === newVal) {
        delete ref.metaData[key];
      }
    },
    compareValue(oldval, newval) {
      if (typeof newval === "object" && typeof oldval === "object") {
        return JSON.stringify(newval) !== JSON.stringify(oldval);
      } else {
        return String(newval) !== String(oldval);
      }
    },
    chainRule(value, rules = []) {
      let valid = true;
      rules.every((rule) => {
        const result = rule(value);
        if (result !== true) {
          valid = result;
          return false;
        }
        return true;
      });
      return valid;
    },
    checkBoxValueCompare(inputValue) {
      return ["1", 1, "true", true].includes(inputValue);
    },
    urlTask(taskName) {
      const taskJsonString = this.$route.query.task;
      let taskJson = {};
      try {
        if (taskJsonString) {
          const reversedString = taskJsonString.split("").reverse().join("");
          const decodedString = atob(reversedString);
          const finalString = decodedString.split("").reverse().join("");
          taskJson = JSON.parse(finalString);
        } else {
          taskJson = {};
        }
      } catch (e) {
        cosnole.log(e);
        return taskJson;
      }
      if (taskJson.task === taskName) {
        const url = new URL(window.location.href);
        try {
          if (taskName === "setType") {
            this.setType("po");
            url.searchParams.delete("task");
          } else if (taskName === "ENV_CONFIG_DIALOG") {
            this.ENV_CONFIG_DIALOG = true;
            url.searchParams.delete("task");
          } else {
            // Unknown task, mark as invalid
            url.searchParams.set("task", "---------invalid--token---------");
            if (this.devEnv) {
              console.error(`Invalid or unsupported task: ${taskName}`);
            }
          }
        } catch (e) {
          url.searchParams.set("task", "---------invalid--token---------");
          if (this.devEnv) {
            console.error(e);
          }
        } finally {
          window.history.pushState(null, "", url.toString());
        }
      }
    },
    ...TestDetailsMixins,
    checkInstallPlugin() {
      const isChrome = this.detectIfChrome();
      const isValidPluginVersion = this.checkPluginVersion();
      if (isChrome) {
        return {
          isChrome: true,
          isPluginInstalled: this.isPluginInstalled,
          validPlugin: isValidPluginVersion,
        };
      }
      return { isChrome: false, isPluginInstalled: this.isPluginInstalled, validPlugin: false };
    },
    checkPluginVersion() {
      let isValid = true;
      if (
        typeof window.functionizePluginVersion != "undefined" &&
        typeof window.publishedChromePluginVersion != "undefined"
      ) {
        const installedPlugin = window.functionizePluginVersion.split(".");
        const basePlugin = window.publishedChromePluginVersion.split(".");
        let skip = false;
        for (let key = 0; key < installedPlugin.length; key++) {
          const installedPluginValue = installedPlugin[key];
          if (isValid) {
            if (!skip) {
              if (
                installedPluginValue &&
                basePlugin[key] &&
                installedPluginValue > basePlugin[key]
              ) {
                skip = true;
              }
              if (
                installedPluginValue &&
                basePlugin[key] &&
                basePlugin[key] > installedPluginValue
              ) {
                isValid = false;
              }
            }
          }
        }
      }
      return isValid;
    },
    detectIfChrome() {
      return true;
    },
  },
  computed: {
    isPluginInstalled() {
      return (
        typeof window.functionizePluginInstalled != "undefined" &&
        window.functionizePluginInstalled != null &&
        window.functionizePluginInstalled
      );
    },
    isProduction() {
      return process.env.NODE_ENV === "production";
    },
    isLocal() {
      return process.env.NODE_ENV === "development";
    },
    onlyForDev() {
      return ["ashvinijdev", "souravdev", "pankajd", "sahildev", "cgi"].includes(
        this.$store.state.window.mode
      );
    },
    www1Env() {
      const url = "www1.functionize.com";
      return window.location.href.includes(url);
    },
    releaseEnv() {
      return ["release"].includes(this.$store.state.window.mode);
    },
    devEnv() {
      return ["dev"].includes(this.$store.state.window.mode);
    },
  },
};